import React, { useEffect, useRef, useState } from 'react';
import Navbar from '../../components/Navbar';
import headerImage from "../../assets/lingotti/0039-Still-life-Care-is-gold-Modifica.webp";
import { FiSearch } from 'react-icons/fi';
import Footer from '../../components/Footer';
import axios from 'axios';
import { Link, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import logo from '../../assets/oroPrestige/logo-trasp.webp';
import Static from '../../components/Static';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Lottie from 'lottie-react';
import loading from '../../assets/lottie/loading.json';

function Notizie() {
  const [searchQuery, setSearchQuery] = useState('');
  const [approfondimenti, setApprofondimenti] = useState([]);
  const [rassegnaStampa, setRassegnaStampa] = useState([]);
  const [visiblePosts, setVisiblePosts] = useState(6);
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [prevSearchQuery, setPrevSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(false);


  const [searchParams, setSearchParams] = useSearchParams();
  const section = searchParams.get('section');

  const [activeTab, setActiveTab] = useState(
    section === 'rassegna-stampa' ? 'rassegna-stampa' : 'approfondimenti'
  );

  const postRefs = useRef({});
  const shouldMoveFocusRef = useRef(false);

  const tabRefs = useRef([]);
  const tabs = ['approfondimenti', 'rassegna-stampa'];

  const resultsStatusMessage =
    searchQuery.trim() === ''
      ? ''
      : filteredPosts.length === 1
        ? `1 risultato trovato per ${searchQuery}.`
        : `${filteredPosts.length} risultati trovati per ${searchQuery}.`;

  useEffect(() => {
    const fetchApprofondimenti = async () => {
      try {
        setIsLoading(true);
        const res = await axios.get(`https://crm.careholding.it/ws/Call/?Cat=Blog&met=GetPostsBlog&np=0`);
        console.log(res.data);
        setApprofondimenti([...res.data].sort((a, b) => new Date(b.DataInserimento) - new Date(a.DataInserimento)));
        if (section !== 'rassegna-stampa') {
          setFilteredPosts([...res.data].sort((a, b) => new Date(b.DataInserimento) - new Date(a.DataInserimento)));

        }
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchApprofondimenti();
  }, []);

  useEffect(() => {
    const fetchRassegnaStampa = async () => {
      try {
        setIsLoading(true);
        const res = await axios.post(`https://crm.careholding.it/ws/Call/?Cat=Blog&met=GetPostsRS&np=0`);
        setRassegnaStampa([...res.data].sort((a, b) => new Date(b.Ordine) - new Date(a.Ordine)));
        if (section === 'rassegna-stampa') {
          setFilteredPosts([...res.data].sort((a, b) => new Date(b.Ordine) - new Date(a.Ordine)));
        }
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRassegnaStampa();
  }, []);

  useEffect(() => {
    const newTab =
      section === 'rassegna-stampa' ? 'rassegna-stampa' : 'approfondimenti';

    setActiveTab(newTab);
    setVisiblePosts(6);

    const sourcePosts =
      newTab === 'rassegna-stampa' ? rassegnaStampa : approfondimenti;

    if (searchQuery.trim() === '') {
      setFilteredPosts(sourcePosts);
    } else {
      const filtered = sourcePosts.filter((post) => {
        const titolo = post.Titolo?.toLowerCase() || '';
        const subtitle = post.Subtitle?.toLowerCase() || '';
        const categoryName = post.CategoryName?.toLowerCase() || '';

        return (
          titolo.includes(searchQuery.toLowerCase()) ||
          subtitle.includes(searchQuery.toLowerCase()) ||
          categoryName.includes(searchQuery.toLowerCase())
        );
      });

      setFilteredPosts(filtered);
    }
  }, [section, approfondimenti, rassegnaStampa, searchQuery]);

  useEffect(() => {
    setPrevSearchQuery(searchQuery);
  }, [searchQuery]);

  useEffect(() => {
    if (!shouldMoveFocusRef.current) return;

    const firstNewIndex = visiblePosts - 3;
    const firstNewPost = filteredPosts.slice(0, visiblePosts)[firstNewIndex];

    if (firstNewPost && postRefs.current[firstNewPost.Id]) {
      postRefs.current[firstNewPost.Id].focus();
    }

    shouldMoveFocusRef.current = false;
  }, [visiblePosts, filteredPosts]);

  // togliere aos transition per mini-screen
  useEffect(() => {
    function initAOS() {
      AOS.init({
        disable: window.innerWidth <= 320 && window.innerHeight <= 256
      });
    }

    initAOS();

    window.addEventListener("resize", () => {
      AOS.refreshHard();
    });
  }, []);

  const selectTab = (tabName) => {
    setActiveTab(tabName);
    setSearchQuery('');
    setVisiblePosts(6);
    setFilteredPosts(tabName === 'approfondimenti' ? approfondimenti : rassegnaStampa);
    let newIndex = tabs.indexOf(tabName);
    tabRefs.current[newIndex]?.focus({ preventScroll: true });

  };

  // const syncTabToUrl = (tabName) => {
  //   const nextParams = new URLSearchParams(searchParams);
  //   nextParams.set('section', tabName);
  //   setSearchParams(nextParams, { replace: true });
  // };

  const handleSubOptionSelect = (tabName, shouldFocus = true) => {
    setActiveTab(tabName);
    setSearchQuery('');
    setVisiblePosts(6);
    setFilteredPosts(tabName === 'approfondimenti' ? approfondimenti : rassegnaStampa);

    const nextParams = new URLSearchParams(searchParams);
    nextParams.set('section', tabName);
    setSearchParams(nextParams, { replace: true });

    if (shouldFocus) {
      const index = tabs.indexOf(tabName);
      requestAnimationFrame(() => {
        tabRefs.current[index]?.focus({ preventScroll: true });
      });
    }
  };

  const handleTabKeyDown = (event, currentIndex) => {
    let newIndex = currentIndex;

    switch (event.key) {
      case 'ArrowRight':
      case 'Right':
        event.preventDefault();
        newIndex = (currentIndex + 1) % tabs.length;
        selectTab(tabs[newIndex]);
        break;

      case 'ArrowLeft':
      case 'Left':
        event.preventDefault();

        newIndex = (currentIndex - 1) % tabs.length;
        selectTab(tabs[newIndex]);

        break;

      default:
        return;
    }


  };

  const showMore = () => {
    shouldMoveFocusRef.current = true;
    setVisiblePosts((prev) => prev + 3);
  };

  const renderPosts = () => {
    return filteredPosts.slice(0, visiblePosts).map((post) => {
      if (post.Stato !== 1) return null;

      return (
        <div
          key={post.Id}
          ref={(el) => {
            if (el) postRefs.current[post.Id] = el;
          }}
          tabIndex={-1}
          className="faq-item border-b-[0.5px] border-neutral-400 p-4 mb-4"
        >
          <Link to={`/notizie/${post.RewriteUrl}/`} className="blogArticle">
            <div className="flex flex-col md:flex-row items-center justify-start text-start grayscale-[80%] hover:grayscale-0 transition duration-1000 ease-in-out blogArticle">
              <div className="max-w-md md:max-w-xs flex-shrink-0 overflow-hidden blogArticle">
                <img
                  src={post.ImgCopertina}
                  alt={post.Titolo}
                  className="shadow-lg transition-transform duration-1000 transform hover:scale-105 blogArticle"
                />
              </div>

              <div className="mx-0 my-8 md:my-0 md:ms-20 blogArticle">
                <h2 className="font-semibold text-black uppercase text-2xl blogArticle">
                  {post.Titolo}
                </h2>
                <p className="text-md mt-2 text-black mb-6 blogArticle">
                  {post.Subtitle}
                </p>
                <span className="flex blogArticle">
                  <p className="px-8 py-2 uppercase border border-black text-black progress-button-dark transition duration-300 ease-in-out blogArticle">
                    Leggi di più
                  </p>
                </span>
              </div>
            </div>
          </Link>
        </div>
      );
    });
  };

  return (
    <div>
      <Helmet>
        <title>Mercato Oro: Ultime Notizie e Analisi | Careisgold</title>
        <meta
          name="description"
          content="Resta aggiornato sul mercato dell'oro con le ultime notizie e analisi di Careisgold. Informazioni affidabili per investitori consapevoli."
        />
        <meta
          name="keywords"
          content="mercato oro, notizie oro, analisi oro, prezzo oro, Careisgold"
        />
        <meta
          property="og:title"
          content="Mercato Oro: Ultime Notizie e Analisi | Careisgold"
        />
        <meta
          property="og:description"
          content="Resta aggiornato sul mercato dell'oro con le ultime notizie e analisi di Careisgold. Informazioni affidabili per investitori consapevoli."
        />
        <meta
          property="og:image"
          content={`https://www.careisgold.it${headerImage}`}
        />
        <meta
          property="og:url"
          content="https://www.careisgold.it/notizie/"
        />
        <meta property="og:type" content="page" />
        <link rel="canonical" href="https://www.careisgold.it/notizie/" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Careisgold SpA",
              "url": "https://www.careisgold.it/notizie/",
              "logo": "https://www.careisgold.it${logo}",
              "description": "Resta aggiornato sul mercato dell'oro con le ultime notizie e analisi di Careisgold. Informazioni affidabili per investitori consapevoli.",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Via Monte Baldo 14/D",
                "addressLocality": "Villafranca di Verona",
                "addressRegion": "Veneto",
                "postalCode": "37069",
                "addressCountry": "IT"
              },
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+39 045 8213155",
                "contactType": "Customer Service"
              },
              "sameAs": [
                "https://www.facebook.com/careisgoldspa",
                "https://www.instagram.com/careisgoldspa",
                "https://www.linkedin.com/company/careisgold-spa"
              ]
            }
          `}
        </script>
      </Helmet>

      <Static
        headerImage={headerImage}
        title="Notizie, approfondimenti e rassegna stampa"
        description="Gli aggiornamenti più recenti, le curiosità e gli articoli della stampa dedicati a Careisgold. Rimani informato sul mondo dell’oro fisico e sulle nostre attività."
        arrow
        logoTransp='' />

      <div className="flex flex-col items-center justify-start flex-grow pb-20 bg-blog">
        <div className="relative mt-20 w-11/12 md:w-1/2">
          <label htmlFor="cerca-input" className="sr-only">
            Cerca notizie. Digitando nel campo, i risultati verranno aggiornati automaticamente.
          </label>
          <input
            type="text"
            id="cerca-input"
            placeholder="Cerca . . ."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="bg-neutral-800 text-slate-50 px-12 py-2 pl-12 focus:outline-none focus:border-blue-500 w-full rounded-lg"
            aria-describedby="search-results-status"
          />
          <span id="search-results-status" className="sr-only" role="status" aria-live="polite">
            {resultsStatusMessage}
          </span>

          <FiSearch
            className="search-icon absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400"
            aria-hidden="true"
            focusable="false"
          />
        </div>

        <div
          role="tablist"
          aria-label="Seleziona la categoria delle notizie"
          className="flex lg:flex-row flex-col mt-10 lg:space-x-20 space-y-5 lg:space-y-0"
        >
          <button
            ref={(el) => (tabRefs.current[0] = el)}
            id="tab-approfondimenti"
            role="tab"
            type="button"
            aria-label="Approfondimenti"
            aria-selected={activeTab === 'approfondimenti'}
            aria-controls="tabpanel-approfondimenti"
            tabIndex={activeTab === 'approfondimenti' ? 0 : -1}
            className={`${activeTab === 'approfondimenti'
              ? 'bg-black text-white'
              : 'text-black'
              } cursor-pointer  border-black px-8 py-2 uppercase border text-center transition duration-300 ease-in-out w-full lg:w-1/2 focus:border-[#b7955a] focus:border-10`}
            onClick={() => handleSubOptionSelect('approfondimenti')}
            onKeyDown={(e) => handleTabKeyDown(e, 0)}
          >
            Approfondimenti
          </button>

          <button
            ref={(el) => (tabRefs.current[1] = el)}
            id="tab-rassegna-stampa"
            role="tab"
            type="button"
            aria-label="Rassegna stampa"
            aria-selected={activeTab === 'rassegna-stampa'}
            aria-controls="tabpanel-rassegna-stampa"
            tabIndex={activeTab === 'rassegna-stampa' ? 0 : -1}
            className={`${activeTab === 'rassegna-stampa'
              ? 'bg-black text-white'
              : 'text-black'
              } cursor-pointer  border-black px-8 py-2 uppercase border text-center transition duration-300 ease-in-out w-full lg:w-1/2`}
            onClick={() => handleSubOptionSelect('rassegna-stampa')}
            onKeyDown={(e) => handleTabKeyDown(e, 1)}
          >
            Rassegna Stampa
          </button>
        </div>

        <div className="mt-16 w-11/12 md:w-7/12">
          <div
            id="tabpanel-approfondimenti"
            role="tabpanel"
            aria-labelledby="tab-approfondimenti"
            hidden={activeTab !== 'approfondimenti'}
          >
            {isLoading ? <div key="loading" className=" flex items-center justify-center">
              <Lottie animationData={loading} loop={true} className="h-32 w-32" />
            </div> : activeTab === 'approfondimenti' && renderPosts()}

          </div>

          <div
            id="tabpanel-rassegna-stampa"
            role="tabpanel"
            aria-labelledby="tab-rassegna-stampa"
            hidden={activeTab !== 'rassegna-stampa'}
          >
            {isLoading ? <div key="loading" className=" flex items-center justify-center">
              <Lottie animationData={loading} loop={true} className="h-32 w-32" />
            </div> : activeTab === 'rassegna-stampa' && renderPosts()}
          </div>

          {filteredPosts.length === 0 && !isLoading && (
            <p className="text-black mt-16">Nessun risultato trovato!</p>
          )}

          {filteredPosts.length > visiblePosts && !isLoading && (
            <button onClick={showMore} className="text-black mt-16">
              Mostra di più . . .
            </button>
          )}
        </div>
      </div>

    </div>
  );
}

export default Notizie;